import request from "@/utils/request";

// 获取航线列表
export const waylineFilePage = async function (
  body: string
): Promise<any> {
  const url = `/uav/wayline/getWayLineList`;
  const result = await request.post(url, body);
  return result.data;
};


// 根据点位id获取图片
export const contrastFileInfo = async function (
  body: any
): Promise<any> {
  const url = `/uav/wayline/contrastFileInfo`;
  const result = await request.post(url, body);
  return result.data;
};

/**
 * 视觉模型图片对比
 *
 * @param data
 */
export async function imageQuestion(data: any) {
  const url = `/uav/recognition/imageComparison`;
  const result = await request.post(url, data);
  return result.data;
}

// 手动添加事件
export const addFlightLogEvent = async function (
  body: eventForm
): Promise<any> {
  const url = `/uav/event/addFlightLogEvent`;
  const result = await request.post(url, body);
  return result.data;
};

//事件统计
export const getEventStatistic = async (body: any): Promise<any> => {
  const url = `/uav/screen/statisticByEvent`;
  const result = await request.post(url, body);
  return result.data;
};

//区域内数量
export const getDroneStatistic = async (body: any): Promise<any> => {
  const url = `/uav/screen/device/droneStatistic`;
  const result = await request.post(url, body);
  return result.data;
};

//飞行数据
export const getFlyStatistic = async (body: any): Promise<any> => {
  const url = `/uav/screen/home/statistics`;
  const result = await request.post(url, body);
  return result.data;
};

export interface eventForm{
  name?:string;
  orgId?:string;
  jobId?:string;
  bizType?:string;
  gatewaySn?:string;
  aircraftSn?:string;
  eventType?:string;
  eventTime?:number;
  description?:string;
  lng?:number;
  lat?:number;
  eventImages?:string;
  box?:any
}